import { useState, useRef, useEffect, } from "react";
import { useParams } from "react-router-dom";
import {
    Box, Button, Card, CardContent,
    Grid2 as Grid,
} from '@mui/material';
import { propComparator, propComparatorDate } from "../utils/ui_utils";

import { get_Category_list } from "../FirebaseUtils/dbCategory";
import  { useEvent } from "../context/eventContext";
import { get_Cow_list } from "../FirebaseUtils/dbCow";
import { globalstyles } from "../lib/definitions";
import { CowSublistDialog } from "../modals/CowSublistDialog";
import { List } from "@mui/icons-material";
import { CowtypeListBadge } from "../components/CowtypeListBadge";




export const PublicCatalogPage = () => {
    const cowlistRef = useRef()

    const { event_id } = useParams()

    const [element_list, setElementList] = useState([])
    const [cow_list, setCowList] = useState([])
    const { selEvent } = useEvent()

    const reloadFn = async () => {
        const data = await get_Category_list(event_id)
        setElementList(data.sort(propComparator('category_number')))
        const cdata = await get_Cow_list(event_id)
        let c_list = cdata.sort(propComparatorDate('birthdate', true, 'catalog_id'))
        c_list.reverse()
        setCowList(c_list)
    }

    const showCowlist = (cl, cat) => {
        cowlistRef.current.onOpen(cl, { id: cat.id, title: cat.category_name + " " + cat.category_description }, true)
    }

    useEffect(() => {
        console.log("VENT_id", event_id, selEvent)
        //setSelEvent(event_id)
        reloadFn()

    }, [event_id])

    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>
            <CowSublistDialog ref={cowlistRef} cow_list={cow_list} is_public />
            <Card sx={{ border: '1px solid lightblue', mt: 1 }}>
                <CardContent>
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={2} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                            Lista categorie
                        </Grid>
                        <Grid size={"grow"} sx={{ textAlign: "right" }}>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ backgroundColor: 'lightgrey' }}>
                        <Grid size="grow">
                            nome
                        </Grid>
                        <Grid size="grow">
                            soggetti<br />
                            <Box sx={{ fontSize: '0.8em', fontStyle: 'italic' }}>black/red</Box>
                        </Grid>
                        <Grid size={1} sx={{ textAlign: 'right' }}>
                        </Grid>
                    </Grid>
                    <Grid >
                        {element_list.filter(s => cow_list.filter(c => c.category && c.category.id === s.id).length>0).map((s, k) => (
                            <OneCategory
                                key={k}
                                category={s}
                                index={k}
                                cow_list={cow_list.filter(c => c.category && c.category.id === s.id)}
                                showCowlist={showCowlist}
                            />
                        ))}
                    </Grid>
                </CardContent>
            </Card>
        </Box >
    );
}


const OneCategory = ({ category, showCowlist, cow_list }) => {
    useEffect(() => {

        const initData = async () => {

        }
        initData()


    }, [category])



    return (
        <Grid container sx={{ ...globalstyles.list_row}}>
            <Grid size={"grow"}>
                <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                    {category.category_name}
                </Grid>
                <Grid size={"grow"} sx={{ fontSize: '0.8em' }}>
                    {category.category_description}
                </Grid>
            </Grid>
            <Grid sx={{ textAlign: "center" }} size={"grow"} justifyContent={"center"} alignContent={"center"} alignItems={"center"} alignSelf={"center"}>
                {cow_list.length}<br />
                <CowtypeListBadge cow_list={cow_list} />
            </Grid>
            <Grid size={"auto"} sx={{ textAlign: 'right' }}>
                {cow_list.length > 0 &&
                    <Button size="small" variant="outlined" color="primary" onClick={() => showCowlist(cow_list, category)} startIcon={<List />} >Soggetti</Button>
                }
            </Grid>
        </Grid>

    )
}




